<template>
  <div class="store-list-content">
    <div class="no_store" v-if="showIndex === 1">
      <img src="@/assets/stores/no_store.png"/>
      <div class="text">Find the best integration for your store.</div>
      <a-button type="primary" @click="$router.push('/personal_center/stores')">Add New Store</a-button>
    </div>
    <div class="store-list" v-if="showIndex === 2">
      <div class="store-item" v-for="platform in storeList" :key="platform.platform">
        <div class="banner">
          <img :src="platform.imgSrc" alt="" srcset="">
        </div>
        <a-radio
          v-for="item in platform.stores"
          :key="item.id"
          :value="item.id"
          :checked="checked === item.id"
          @click="change(item)"
          class="radio_item"
          >{{ item.name }}</a-radio
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getUserStore } from '@/api/order'
export default {
  name: 'StoreListContent',
  data() {
    return {
      storeList: [],
      checked: '',
      showIndex: 0,
      platform: ''
    }
  },
  methods: {
    change(e) {
      this.checked = e.id
      this.platform = e.platform
    }
  },
  mounted() {
    getUserStore({ auth_status: 1, group_by: 'platform' }).then((res) => {
      this.storeList = res.data
      this.storeList.forEach(item => {
        item.imgSrc = require('@/assets/stores/' + item.name + '_publish.png')
      })
      if (this.storeList.length > 0) {
        this.showIndex = 2
      } else {
        this.showIndex = 1
      }
    })
  }
}
</script>

<style lang="less" scoped>
.store-list-content {
  padding: 30px;
  .store-list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .store-item {
      width: 48%;
      padding: 10px 20px;
      border: 1px solid #D9D9D9;
      border-radius: 4px;
      display: flex;
      flex-flow: column;
      margin: 10px 0;
      .banner {
        padding: 10px 0;
        border-bottom: 1px solid #D9D9D9;
      }
      .radio_item {
        padding: 5px 0;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }
  .no_store {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    .text {
      margin: 24px 0;
      font-size: 24px;
      font-family: Source Han Sans SC;
      font-weight: 500;
      color: #666666;
    }
  }
}
@media screen and(max-width: 960px) {
  .store-list-content {
    padding: 30px;
    .store-list {
      flex-flow: column;
      .store-item {
        width: 100%;
      }
    }
  }
}
</style>
